import '../styles/components/Navbar.scss'
import logo from '../assets/logo.svg'
import { Link, useNavigate } from 'react-router-dom'
import { useState } from 'react';
import { HiChevronDown } from "react-icons/hi";
import { IoMenu, IoCloseOutline  } from "react-icons/io5";
import { IoChevronForwardOutline, IoChevronDownOutline } from "react-icons/io5";
import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [isServicesExpanded, setIsServicesExpanded] = useState(false)
    
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen)
        setIsServicesExpanded(false)
    }

    const closeMenu = () => {
        setIsMenuOpen(false)
        setIsServicesExpanded(false)
    }

    const handleNavigation = (path) => {
        navigate(path)
        closeMenu()
    }

    const toggleServices = () => {
        setIsServicesExpanded(!isServicesExpanded)
    }

    return(
        <>
            <div className="navbar-container">
                <div className='logo-container' onClick={() => navigate('/')}>
                    <img src={logo} alt='logo 2SC Consulting' />
                </div>
                <nav>
                    <Link to='/'> {t('nav.home')} </Link>
                    <Link to='/AboutUs'> {t('nav.about')} </Link>
                    <div className="nav-item-with-submenu">
                    <div className='products-nav-menu'> {t('nav.services')} <HiChevronDown /> </div>
                        <div className="submenu">
                            <Link to='/creation-entreprise'>{t('nav.creation')}</Link>
                            <hr />
                            <Link to='/domiciliation-entreprise'>{t('nav.domiciliation')}</Link>
                            <hr />
                            <Link to='/comptabilite'>{t('nav.comptabilite')}</Link>
                        </div>
                    </div>
                    <Link to='/FAQ'> {t('nav.faq')} </Link>
                </nav>
                <div className='nav-right'>
                    <LanguageSwitcher />
                    <Link to='/Contact'> {t('nav.contact')} </Link>
                </div>
                <div className='mobile-utils'>
                    <LanguageSwitcher />
                    <button 
                        className={`hamburger-menu ${isMenuOpen ? 'active' : ''}`}
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        {!isMenuOpen === true ? <IoMenu size={48} /> : <IoCloseOutline size={48} />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            <div className={`mobile-menu-overlay ${isMenuOpen ? 'active' : ''}`}>
                <div className="mobile-nav">
                    <a onClick={() => handleNavigation('/')}>{t('nav.home')}</a>
                    <a onClick={() => handleNavigation('/AboutUs')}>{t('nav.about')}</a>
                    <div className="mobile-services-item">
                        <a onClick={toggleServices} className="services-toggle">
                            {t('nav.servicesMenu')}
                            {isServicesExpanded ? <IoChevronDownOutline /> : <IoChevronForwardOutline />}
                        </a>
                        {isServicesExpanded && (
                            <div className="mobile-services-submenu">
                                <a onClick={() => handleNavigation('/creation-entreprise')}>{t('nav.creation')}</a>
                                <a onClick={() => handleNavigation('/comptabilite')}>{t('nav.comptabilite')}</a>
                                <a onClick={() => handleNavigation('/domiciliation-entreprise')}>{t('nav.domiciliation')}</a>
                            </div>
                        )}
                    </div>
                    <a onClick={() => handleNavigation('/FAQ')}>{t('nav.faq')}</a>
                </div>
                <button className="mobile-contact-button" onClick={() => handleNavigation('/Contact')}>
                    {t('nav.contact')}
                </button>
            </div>
        </>
    )
}

export default Navbar
